import { Maybe } from 'graphql/jsutils/Maybe';
import isString from 'lodash/isString';

import { IAddress } from '@r-client/data/graphql-types';

export type TEventAddress = Pick<
  IAddress,
  'street1' | 'street2' | 'city' | 'country' | 'state' | 'postalCode'
>;

const isNotEmptyString = (str: Maybe<string>) => isString(str) && str.length;

const formatAsSingleString = (
  strList: Maybe<string>[],
  joinPattern: string
) => {
  return strList.filter(isNotEmptyString).join(joinPattern);
};

export const getEventFullAddress = (address: TEventAddress) => {
  return formatAsSingleString(
    [
      formatAsSingleString([address.street1, address.street2], ' '),
      address.city,
      formatAsSingleString([address.state, address.postalCode], ' '),
      address.country,
    ],
    ', '
  );
};
